import { WelcomeStepsData } from "../types";

export const welcomeStepsData: WelcomeStepsData[] = [
  {
    id: 1,
    title: "What's your gender?",
    heading: "What's your gender?",
    description: "",
    form: [
      {
        field: "radio",
        name: "gender",
        label: "Male",
        value: "Male",
        inputVisible: true,
      },
      {
        field: "radio",
        name: "gender",
        label: "Female",
        value: "Female",
        inputVisible: true,
      },
      {
        field: "radio",
        name: "gender",
        label: "Other",
        value: "Other",
        inputVisible: true,
      },
    ],
  },
  {
    id: 2,
    title: "What is your current height and weight?",
    heading: "What is your current height and weight?",
    description: "",
    form: [
      {
        field: "input",
        name: "weight",
        inputVisible: true,
        label: "Enter your current weight",
        value: "",
        placeholder: "e.g. 180",
        type: "text",
      },
      {
        field: "input",
        name: "height",
        inputVisible: true,
        label: "Enter your current height",
        value: "",
        placeholder: "e.g. 4'11'",
        type: "text",
      },
    ],
  },
  {
    id: 3,
    title: "What is your target weight goal, and in how many months do you want to achieve it?",
    heading: "What is your target weight goal, and in how many months do you want to achieve it?",
    description: "",
    form: [
      {
        field: "input",
        name: "targetWeight",
        inputVisible: true,
        label: "Your target weight",
        value: "",
        placeholder: "E.g 180",
        type: "text",
      },
      {
        field: "input",
        name: "timeframe",
        inputVisible: true,
        label: "What’s your timeframe for this target?",
        value: "",
        placeholder: "E.g. 4 months",
        type: "text",
      },
    ],
  },
  {
    id: 4,
    title: "Do you have any events or trips planned that are motivating your weight loss goal?",
    heading: "Do you have any events or trips planned that are motivating your weight loss goal?",
    description: "",
    form: [
      {
        field: "checkbox",
        name: "events",
        inputVisible: true,
        label: "Wedding",
        value: "Wedding",
      },
      {
        field: "checkbox",
        name: "events",
        inputVisible: true,
        label: "Vacation",
        value: "Vacation",
      },
      {
        field: "checkbox",
        name: "events",
        inputVisible: true,
        label: "Reunion",
        value: "Reunion",
      },
      {
        field: "checkbox",
        name: "events",
        inputVisible: true,
        label: "Health Reasons",
        value: "Health Reasons",
      },
      {
        field: "checkbox",
        name: "events",
        label: "Other",
        value: "Other",
        inputVisible: true,
      },
    ],
  },
  {
    id: 5,
    title: "Are you currently on any weight loss medications?",
    heading: "Are you currently on any weight loss medications?",
    description: "",
    form: [
      {
        field: "radio",
        name: "onMedication",
        inputVisible: true,
        label: "Yes",
        value: "Yes",
      },
      {
        field: "radio",
        name: "onMedication",
        inputVisible: true,
        label: "No",
        value: "No",
      },
    ],
  },
  {
    id: 6,
    title: "Have you ever been on a GLP-1 medication (Wegovy, Ozempic, Zepbound, Tirzepatide, Semaglutide, or Mounjaro)?",
    heading: "Have you ever been on a GLP-1 medication (Wegovy, Ozempic, Zepbound, Tirzepatide, Semaglutide, or Mounjaro)?",
    description: "",
    form: [
      {
        field: "radio",
        name: "glpIntake",
        inputVisible: true,
        label: "Yes",
        value: "Yes",
      },
      {
        field: "radio",
        name: "glpIntake",
        inputVisible: true,
        label: "No",
        value: "No",
      },
    ],
  },
  {
    id: 7,
    title: "Have you ever been on a GLP-1 medication (Wegovy, Ozempic, Zepbound, Tirzepatide, Semaglutide, or Mounjaro)?",
    heading: "Have you ever been on a GLP-1 medication (Wegovy, Ozempic, Zepbound, Tirzepatide, Semaglutide, or Mounjaro)?",
    description: "",
    form: [
      {
        field: "input",
        name: "recentdose",
        inputVisible: true,
        label: "What was your most recent dose?",
        value: "",
        placeholder: "E.g 4mg",
        type: "text",
      },
      {
        field: "input",
        name: "lastintake",
        inputVisible: true,
        label: "When did you last take it?",
        value: "",
        placeholder: "E.g Last week",
        type: "text",
      },
    ],
  },
  {
    id: 8,
    title: "Do you have a personal or family history of any of the following conditions?",
    heading: "Do you have a personal or family history of any of the following conditions?",
    description: "",
    form: [
      {
        field: "checkbox",
        name: "healthCondition",
        inputVisible: true,
        label: "MEN1 (Multiple endocrine neoplasia Type 1)",
        value: "MEN1 (Multiple endocrine neoplasia Type 1)",
      },
      {
        field: "checkbox",
        name: "healthCondition",
        inputVisible: true,
        label: "MEN2 (Multiple endocrine neoplasia Type 2)",
        value: "MEN2 (Multiple endocrine neoplasia Type 2)",
      },
      {
        field: "checkbox",
        name: "healthCondition",
        inputVisible: true,
        label: "Thyroid cancer",
        value: "Thyroid cancer",
      },
      {
        field: "checkbox",
        name: "healthCondition",
        inputVisible: true,
        label: "Pancreatic cancer",
        value: "Pancreatic cancer",
      },
      {
        field: "checkbox",
        name: "healthCondition",
        inputVisible: true,
        label: "None of the above",
        value: "None of the above",
      },
    ],
  },
  {
    id: 9,
    title: "Do you have a current or previous history of Pancreatitis?",
    heading: "Do you have a current or previous history of Pancreatitis?",
    description: "",
    form: [
      {
        field: "radio",
        name: "history",
        inputVisible: true,
        label: "Yes",
        value: "Yes",
      },
      {
        field: "radio",
        name: "history",
        inputVisible: true,
        label: "No",
        value: "No",
      },
    ],
  },

];
